import { Avatar, BigCard, StatusBadge } from "./bits";
import { Store, Mic, Package, Music, ShoppingBag, CalendarCheck, Mail, User } from "lucide-react";

/* ক্রিয়েটর-ঘর — কর্পোরেট ড্যাশবোর্ড নয়; নিজের দোকান-মঞ্চের খাতা */
export default function Home({ creator, data, onNav, onExit, onLogout }) {
  const isArtist = creator.creator_type === "artist";
  const modeTitle = isArtist ? "আমার রং ও মঞ্চ" : "আমার রঙের হাট";
  const place = creator.location || (data.artist ? data.artist.location : "") || "";
  const stageLive = data.artist ? data.artist.active !== false : data.shop?.active !== false;
  const counts = {
    items: isArtist ? (data.performances || []).length : (data.products || []).length,
    requests: isArtist ? (data.bookings || []).filter((b) => b.status !== "নিশ্চিত" && b.status !== "বাতিল").length : (data.orders || []).length,
    msgs: (data.enquiries || []).length,
  };

  return (
    <div className="mx-auto max-w-3xl px-5 py-8 sm:px-8" data-testid="creator-home">
      {/* নিজের পরিচয় */}
      <div className="flex flex-wrap items-center gap-5 rounded-2xl border border-gold/20 bg-plaster/80 p-6 sm:p-8">
        <Avatar photo={creator.photo} name={creator.name} />
        <div className="min-w-0 flex-1">
          <h1 className="font-display text-3xl leading-snug text-alpana" data-testid="creator-home-name">{creator.name}</h1>
          <p className="mt-1 text-sm text-sand/70">{creator.craft || (isArtist ? "লোকশিল্পী" : "শিল্পকার")}</p>
          {place && <p className="mt-0.5 text-xs text-sand/50">{place}</p>}
        </div>
        {creator.verified !== false && (
          <span className="flex items-center gap-1.5 rounded-full border border-gold/50 bg-gold/10 px-3.5 py-1.5 text-[11px] text-gold" data-testid="creator-verified">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            Verified Creator
          </span>
        )}
      </div>

      <p className="mt-8 text-center font-display text-2xl text-gold/90">{modeTitle}</p>

      <div className="mt-5 space-y-3">
        <BigCard
          icon={isArtist ? Mic : Store}
          title={isArtist ? "আমার মঞ্চ" : "আমার দোকান"}
          sub={isArtist ? (data.artist?.art_form || "") : (data.shop?.name || "")}
          count={null}
          onClick={() => onNav(isArtist ? "stage" : "shop")}
          testid="home-card-shop"
        />
        <BigCard
          icon={isArtist ? Music : Package}
          title={isArtist ? "আমার পরিবেশনা" : "আমার পণ্য"}
          sub={isArtist ? "গান, ভিডিও, শো-রিল" : "ছবি, দাম, মজুত"}
          count={counts.items}
          onClick={() => onNav(isArtist ? "performances" : "products")}
          testid="home-card-items"
        />
        <BigCard
          icon={isArtist ? CalendarCheck : ShoppingBag}
          title={isArtist ? "বুকিং-অনুরোধ" : "অর্ডার-রসিদ"}
          sub={isArtist ? "কার অনুষ্ঠানে যাবেন" : "কার জিজ্ঞেস-রসিদ এলো"}
          count={counts.requests}
          onClick={() => onNav(isArtist ? "requests" : "orders")}
          testid="home-card-orders"
        />
        <BigCard
          icon={Mail}
          title="জিজ্ঞেস-বার্তা"
          sub="ক্রেতার কথা"
          count={counts.msgs}
          onClick={() => onNav("messages")}
          testid="home-card-messages"
        />
        <BigCard
          icon={User}
          title="প্রোফাইল ও QR"
          sub="নাম, ছবি, গল্প, যোগাযোগ"
          count={null}
          onClick={() => onNav("profile")}
          testid="home-card-profile"
        />
      </div>

      {/* দোকান/মঞ্চের অবস্থা — হাতের কাছেই */}
      <div className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-gold/15 bg-earthen/60 p-5">
        <div>
          <p className="text-sm text-sand/75">{isArtist ? "মঞ্চের অবস্থা" : "দোকানের অবস্থা"}</p>
          <StatusBadge live={stageLive} testid="home-status-badge" />
        </div>
        <div className="flex gap-2">
          <button
            data-testid="home-see-customer-view"
            onClick={() => onNav(isArtist ? "stage" : "shop")}
            className="rounded-full border border-gold/40 px-5 py-2.5 text-sm text-gold transition-colors hover:bg-gold hover:text-dusk"
          >
            {isArtist ? "Stage দেখুন" : "Shop দেখুন"}
          </button>
          <button
            data-testid="home-logout"
            onClick={onLogout}
            className="rounded-full border border-red-400/30 px-5 py-2.5 text-sm text-red-300 transition-colors hover:bg-red-400 hover:text-dusk"
          >
            বেরিয়ে যান
          </button>
        </div>
      </div>

      <button
        data-testid="creator-back-village"
        onClick={onExit}
        className="mt-6 w-full rounded-xl border border-gold/25 px-4 py-3 text-sm text-gold transition-colors hover:bg-gold hover:text-dusk"
      >
        ← গ্রামে ফিরুন
      </button>
    </div>
  );
}
